import { API } from '@utils/axios'
import { appendParams } from '@utils/func'
import { IAPI } from 'AppTypes'

class InvoiceManagementAPI implements IAPI {
  prefix = '/Invoice'

  fetchList (params: TInvoiceManagementAPI.Params.list) {
    let url = `${this.prefix}`
    const customLogicArray:any = {}
    const customLogicParams:any = params
    Object.keys(customLogicParams).forEach(key => {
      if (Array.isArray(customLogicParams[key]) && customLogicParams[key].length > 0) {
        customLogicArray[key] = [...customLogicParams[key] || []]
        delete customLogicParams[key]
      }
    })
    url = appendParams(url, params)
    Object.keys(customLogicArray).forEach(key => {
      const hasQuestionMark = url.indexOf('?') > 0
      url = `${url}${hasQuestionMark ? '&' : '?'}${customLogicArray[key].map((e: string) => `InvoiceStatus=${e}`).join('&')}`
    })

    return API.get(url)
  }

  fetchDetailHistory (InvoiceId: string) {
    return API.get(`InvoiceLogHistory/details?InvoiceId=${InvoiceId}`)
  }

  createInvoiceHistory (params: TInvoiceManagementAPI.Params.createHistory) {
    return API.post('InvoiceLogHistory/create', params)
  }
}

export const invoiceManagementAPI = new InvoiceManagementAPI()
